import React from 'react';
import { Navigate } from 'react-router-dom';

import { ERoleAccess } from '@/enum';
import useAccess from '@/hooks/useAccess';
import useUser from '@/store/useUser';

export const PrivateRoute = ({
  children,
  section,
}: {
  children: React.ReactNode;
  section?: ERoleAccess | ERoleAccess[];
}) => {
  const {
    user: { token },
  } = useUser();

  const { hasAccess, isFullAccess } = useAccess();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (isFullAccess) {
    return <>{children}</>;
  }

  if (section) {
    const requiredSections = Array.isArray(section) ? section : [section];
    const hasAnySectionAccess = requiredSections.some((sec) => hasAccess(sec));

    if (!hasAnySectionAccess) {
      return <Navigate to="/" replace />; // Redirect to dashboard instead of login
    }
  }

  return <>{children}</>;
};

export const SectionGuard = ({
  children,
  section,
}: {
  children: React.ReactNode;
  section: ERoleAccess;
}) => {
  const { hasAccess, isFullAccess } = useAccess();

  if (isFullAccess) return <>{children}</>;

  if (!hasAccess(section)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export const PublicRoute = ({ children }: { children: React.ReactNode }) => {
  const {
    user: { token },
  } = useUser();

  return token ? <Navigate to="/" replace /> : <>{children}</>;
};
